import cookieStorage from 'assets/js/editor/utils/cookie-storage';

export class CredentialsInterceptor {
  hasValidCredentials = true;

  validationTimeout = 1000 * 60 * 30; // 30 minutes

  targetErrorMessages = [
    'Internal Server Error',
    'Permission is not granted',
    'Invalid credentials'
  ];

  overrideGlobalCredentials = () => {
    try {
      const userHash = cookieStorage.get('user_hash');
      const userToken = cookieStorage.get('user_token');

      if (userHash && userToken) {
        CONFIG.credentials.hash = userHash;
        CONFIG.credentials.token = userToken;
      }
    } catch (error) {
      console.error('Error overriding global credentials', error);
    }
  };

  registerInterceptors () {
    if (INKIVE.C.IS_MOBILE_APP) return;

    this.registerFetchInterceptor();
    this.registerJQueryInterceptor();

    setTimeout(this.validateCredentials, this.validationTimeout);
  }

  isErrorResponse = (request) => {
    const error = request && request.statusText;

    if ([200, 204].includes(request.status)) {
      this.hasValidCredentials = true;
    }

    if (!error && [401, 403].includes(request.status)) {
      return request.url.includes('https://api.');
    }

    return (error && this.targetErrorMessages.some(message => request.statusText.includes(message)));
  };

  registerJQueryInterceptor = () => {
    $(document).ajaxError((event, request, settings) => {
      const url = settings.url;

      if (url.match(/(\/api\/|\/updateSettings)/) &&
        url.match(/^((?!\/errortrack\/).)*$/) &&
        this.isErrorResponse(request)
      ) {
        this.loadLoginModalOnInvalidCredentials();
      }
    });
  };

  registerFetchInterceptor = () => {
    const { fetch: originalFetch } = window;

    window.fetch = async (...args) => {
      const [resource, config] = args;
      const request = await originalFetch(resource, config);

      if (this.isErrorResponse(request)) {
        this.loadLoginModalOnInvalidCredentials();

        return Promise.reject(request);
      }

      return request;
    };
  };

  loadLoginModalOnInvalidCredentials = async () => {
    if (!this.hasValidCredentials) return;

    const hasValidCredentials = await INKIVE.Helpers.isCredentialsValid();

    this.hasValidCredentials = hasValidCredentials;

    if (!hasValidCredentials) {
      INKIVE.Helpers.displayAccessModal({ useLoginModal: true });
    }
  };

  validateCredentials = async () => {
    const hasValidCredentials = await INKIVE.Helpers.isCredentialsValid();

    if (hasValidCredentials) {
      setTimeout(this.validateCredentials, this.validationTimeout);

      return;
    }

    INKIVE.Helpers.displayAccessModal({ useLoginModal: true });
  };
}
